import type { VoiceCategory } from '../../../_types/form'


import { cls } from 'tagged-classnames-free';
interface VoiceCategoryListProps {
  categories: VoiceCategory[]
  activeKey: string
  onChange: (key: string) => void
}

function VoiceCategoryList(props: VoiceCategoryListProps) {
  const { categories, activeKey, onChange } = props

  return (
    <div className={cls`flex flex-col gap-3`}>
      {categories.map((category) => {
        const isActive = activeKey === category.key
        return (
          <button
            key={category.key}
            type='button'
            className={cls`
              cursor-pointer rounded-md p-1 pl-0 text-left text-sm font-semibold transition-colors
              ${isActive ? 'text-f-text' : 'text-f-text-tertiary hover:text-f-text-secondary'}
            `}
            onClick={() => onChange(category.key)}
          >
            {category.displayName}
          </button>
        )
      })}
    </div>
  )
}

export default VoiceCategoryList
